import React from 'react';

import { getRouteApi } from '@tanstack/react-router';
import { LOAN_REQUEST_COMMANDS, RESIDENCE_PERMIT_TYPES } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormDropdown } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDropdown';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaPersonal } from '~/features/leadDetails/schemas/personal.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type AufenthaltstitelProps = {
    antragsteller: 1 | 2;
};

const Aufenthaltstitel: React.FC<AufenthaltstitelProps> = ({ antragsteller }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaPersonal>();

    const options = Object.values(RESIDENCE_PERMIT_TYPES).map((value) => ({
        label: t(`RESIDENCE_PERMIT_TYPES.${value}`),
        value,
    }));

    return (
        <FormDropdown
            control={control}
            id={`antragsteller${antragsteller}.personendaten.aufenthaltstitel`}
            label={t('PERSONAL_DATA.RESIDENCE_PERMIT')}
            options={options}
            disabled={
                !canExecuteApplicantCommand({
                    applicant: antragsteller,
                    commandName: LOAN_REQUEST_COMMANDS.updateApplicantResidenceData,
                    permissions,
                })
            }
        />
    );
};

export default Aufenthaltstitel;
